export class NoborhUploadSource {
  public noborhUploadSource: number;
  public uploadSource: string;

  constructor(init?: any) {
    Object.assign(this, init);
  }
}
